module.exports = __webpack_public_path__ + "static/media/4.621d5f81.jpg";